import axios from 'axios';

export default axios.create({
  baseURL: 'http://danielperezlorenzo.com:8080/api',
  headers: {
    'Authorization' : 'Bearer '+window.localStorage.getItem('dpl-be-access-token')
  }
});